import React, { FC } from 'react'
import * as pageUtils from './__details.utils'

const ElderSubventionRenewalFormDetails: FC<pageUtils.Props> = ({
	pageAssets,
	request
}) => {
	return (
		<>
			<h4 className={pageUtils.classes.h4}>
				{pageAssets?.request_form_elderSubvention_firstSubStep_title}
			</h4>

			<div>
				<b>{pageAssets?.request_form_elderSubvention_firstTimeSubmit_label}</b>
				<br />
				<p className={pageUtils.classes.paragraph}>
					{request.incidentForm?.firstTimeSubmit
						? pageAssets?.label_yes
						: pageAssets?.label_no}
				</p>
			</div>

			{request.incidentForm?.firstTimeSubmit && (
				<div>
					<b>{pageAssets?.request_form_elderSubvention_clientNumber_label}</b>
					<br />
					<p className={pageUtils.classes.paragraph}>
						{request.incidentForm?.clientNumber}
					</p>
				</div>
			)}

			{!request.incidentForm?.firstTimeSubmit && (
				<>
					<div>
						<b>{pageAssets?.request_form_elderSubvention_clientAge_label}</b>
						<br />
						<p className={pageUtils.classes.paragraph}>
							{request.incidentForm?.clientAge}
						</p>
					</div>
				</>
			)}

			<h4 className={pageUtils.classes.h4}>
				{pageAssets?.request_form_parkingPermit_address_of_request}
			</h4>

			{request.incidentForm?.firstTimeSubmit && (
				<div>
					<b>
						{
							pageAssets?.request_form_elderSubvention_clientCorrectAddress_label
						}
					</b>
					<br />
					<p className={pageUtils.classes.paragraph}>
						{request.incidentForm?.clientCorrectAddress
							? pageAssets?.label_yes
							: pageAssets?.label_no}
					</p>
				</div>
			)}

			{request.incidentForm?.concernedAdresse && (
				<div>
					<b>{pageAssets?.label_address}</b>
					<br />
					<p className={pageUtils.classes.paragraph}>
						{request.incidentForm?.concernedAdresse}
					</p>
				</div>
			)}
			{request.incidentForm?.concernedAppartement && (
				<div>
					<b>{pageAssets?.label_apartment_office}</b>
					<br />
					<p className={pageUtils.classes.paragraph}>
						{request.incidentForm?.concernedAppartement}
					</p>
				</div>
			)}

			{!request.incidentForm?.clientCorrectAddress &&
				request.incidentForm?.firstTimeSubmit && (
					<div>
						<b>
							{pageAssets?.request_form_elderSubvention_moveDate_radio_label}
						</b>
						<br />
						<p className={pageUtils.classes.paragraph}>
							{request.incidentForm?.moveDate
								? new Date(request.incidentForm?.moveDate).toLocaleDateString()
								: 'N/A'}
						</p>
					</div>
				)}

			<div>
				<b>
					{pageAssets?.request_form_elderSubvention_isClientHouseOwner_label}
				</b>
				<br />
				<p className={pageUtils.classes.paragraph}>
					{request.incidentForm?.isClientHouseOwner
						? pageAssets?.label_yes
						: pageAssets?.label_no}
				</p>
			</div>

			{request.incidentForm?.firstTimeSubmit &&
				request.incidentForm?.isClientHouseOwner && (
					<div>
						<b>
							{
								pageAssets?.request_form_elderSubvention_renewal_form_renter_label
							}
						</b>
						<br />
					</div>
				)}

			<h4 className={pageUtils.classes.h4}>
				{pageAssets?.request_form_elderSubvention_thirdSubStep_title ||
					'Informations supplémentaires'}
			</h4>

			<div>
				<b>
					{pageAssets?.request_form_elderSubvention_income_supplement_label}
				</b>
				<br />
				<p className={pageUtils.classes.paragraph}>
					{request.incidentForm?.incomeSupplementRadio
						? pageAssets?.label_yes
						: pageAssets?.label_no}
				</p>
			</div>

			{request.incidentForm?.incomeSupplementRadio && (
				<>
					<div>
						<b>
							{
								pageAssets?.request_form_elderSubvention_income_supplement_text_label
							}
						</b>
						<br />
						<p className={pageUtils.classes.paragraph}>
							{request.incidentForm?.incomeSupplementText}
						</p>
					</div>
				</>
			)}

			<div>
				<b>
					{pageAssets?.request_form_elderSubvention_co_beneficiary_radio_label}
				</b>
				<br />
				<p className={pageUtils.classes.paragraph}>
					{request.incidentForm?.coBeneficiaryRadio
						? pageAssets?.label_yes
						: pageAssets?.label_no}
				</p>
			</div>

			{request.incidentForm?.coBeneficiaryRadio && (
				<>
					{request.incidentForm?.coBeneficiaryFirstName && (
						<div>
							<b>
								{
									pageAssets?.request_form_elderSubvention_co_beneficiary_firstname_label
								}
							</b>
							<br />
							<p className={pageUtils.classes.paragraph}>
								{request.incidentForm?.coBeneficiaryFirstName}
							</p>
						</div>
					)}
					{request.incidentForm?.coBeneficiaryLastName && (
						<div>
							<b>
								{
									pageAssets?.request_form_elderSubvention_co_beneficiary_lastname_label
								}
							</b>
							<br />
							<p className={pageUtils.classes.paragraph}>
								{request.incidentForm?.coBeneficiaryLastName}
							</p>
						</div>
					)}
					{request.incidentForm?.coBeneficiaryDate && (
						<div>
							<b>
								{
									pageAssets?.request_form_elderSubvention_co_beneficiary_date_label
								}
							</b>
							<br />
							<p className={pageUtils.classes.paragraph}>
								{new Date(request.incidentForm?.coBeneficiaryDate).toLocaleDateString()}
							</p>
						</div>
					)}
				</>
			)}
		</>
	)
}

export default ElderSubventionRenewalFormDetails
